module.exports = __webpack_public_path__ + "img/ticket_icon_message_win.5155a1d6.svg";